import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

import FormOne from "./FormOne";
import EditButtons from "../../../components/EditButtons";
import { CancelButton } from "../../css components/Button";
import { ButtonFooter, PageHeader, Paper } from "../../../components";
import pages from "../../../constants/pages";

export default function FormDisplay({
  state,
  dispatch,
  fields,
  editState,
  setEditState,
  formikProps,
  component,
}) {
  const navigate = useNavigate();

  const countMandatoryTrue = () => {
    return fields.ioh.filter((field) => state[field.name]?.mandatory === true)
      .length;
  };

  const countFilledFields = () => {
    let allFields = [...fields.ioh, ...fields.other];
    return allFields.filter((key) => state[key.name] !== undefined).length;
  };
  const isSubmitDisabled = countFilledFields() > 5;

  const countMandatory = countMandatoryTrue() < 2;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {component !== "dialog" && (
          <PageHeader
            pageName={"Audience"}
            pageHeader={
              !formikProps.values.audienceID
                ? "Let's create audience "
                : formikProps.values.audience_group?.value
            }
            buttons={[
              formikProps.values.isEditable ? (
                <EditButtons
                  path={pages.audienceList.route}
                  editState={editState}
                  setEditState={setEditState}
                />
              ) : (
                <CancelButton
                  variant="outlined"
                  onClick={() => navigate(pages.audienceList.route)}
                >
                  Back
                </CancelButton>
              ),
            ]}
          />
        )}
      </Grid>

      <Grid item xs={12}>
        <Paper gridSpacing={8}>
          <FormOne
            countSelectedIOH={countMandatoryTrue}
            state={state}
            dispatch={dispatch}
            fields={fields}
            formikProps={formikProps}
            editState={editState}
            setEditState={setEditState}
          />
        </Paper>

        {editState && (
          <Grid item xs={12}>
            <ButtonFooter
              path={pages.audienceList.route}
              disabled={isSubmitDisabled || countMandatory}
              ID={formikProps.values.ID}
              editState={editState}
              setEditState={setEditState}
              formikProps={{
                ...formikProps,
                dirty: true,
              }}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
